export default __webpack_public_path__ + "static/media/Ashtrays_TomDixon.18ad6a0e.jpg";